import { render, staticRenderFns } from "./ProfileChat.vue?vue&type=template&id=799e5e54&scoped=true&"
import script from "./ProfileChat.vue?vue&type=script&lang=js&"
export * from "./ProfileChat.vue?vue&type=script&lang=js&"
import style0 from "./ProfileChat.vue?vue&type=style&index=0&id=799e5e54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799e5e54",
  null
  
)

export default component.exports